var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-steps"},[_c('ProgressBarSteps',{attrs:{"value":_vm.value,"targetSteps":_vm.targetSteps}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }